import { utilityService } from './../services/utility/utility.service';
import { PubSubService } from './../service/pubSub.service';
import { socialService } from '../services/social/social.service';
var productsComponent = (function () {
    /**
     * @param sService for getting products data
     * @param pubsub for subscribing to the getData event
     */
    function productsComponent(sService, pubsub, utilityS) {
        var _this = this;
        this.sService = sService;
        this.pubsub = pubsub;
        this.utilityS = utilityS;
        this.productsDataArr = []; // the array of object which forms the card list view
        this.selectedCategoryName = 'products'; // default selected option in products component view
        this.productsDataArr = [];
        /**
        *  Subscribe to the getData event
        */
        this.getDataSub = this.pubsub.$sub('getData', function (eventObject) {
            _this.getSetimentsByCategory();
        });
    }
    /**
     * 1. Initialize config options for line chart
     * 2. getSentiments data service call
     */
    productsComponent.prototype.ngOnInit = function () {
        /**
         * The default configuration for graph displayed in each card
         */
        this.options = {
            animation: {
                duration: 0
            },
            maintainAspectRatio: false,
            legend: { display: false },
            scales: {
                xAxes: [{
                        display: false,
                        gridLines: {
                            display: false,
                            drawBorder: false
                        }
                    }],
                yAxes: [{
                        display: false,
                        gridLines: {
                            display: false,
                            drawBorder: false
                        }
                    }]
            },
            elements: {
                line: {
                    tension: 0
                }
            },
            tooltips: {
                enabled: false
            }
        };
        /**
         * get the sentiments data by category on initialization
         * of the component
         */
        this.getSetimentsByCategory();
    };
    productsComponent.prototype.ngOnChanges = function (changes) {
        // products is the second tab in the tab group so it's currentIndex or currentValue == 1
        if (changes['tabChange'] && changes['tabChange'].currentValue === 1) {
            this.utilityS.applyConditionalCss();
            this.getSetimentsByCategory();
        }
    };
    /**
     * Gets called everytime the selected option for the card view
     * should be changed
     * @param selectedName Current selected option string
     */
    productsComponent.prototype.selectedChange = function (selectedName) {
        this.selectedCategoryName = selectedName;
        this.getSetimentsByCategory();
    };
    /**
     * Method for doing the necessary initialization before making
     * the service call
     */
    productsComponent.prototype.getSetimentsByCategory = function () {
        var _this = this;
        this.productsDataArr = [];
        if (this.selectedCategoryName) {
            this.sService.getSetimentsByCategory(this.selectedCategoryName).subscribe(function (result) {
                _this.productsDataArr = result;
            });
        }
    };
    /**
     * 1. unsubscribe the timer before the component is destroyed
     */
    productsComponent.prototype.ngOnDestroy = function () {
        this.getDataSub.unsubscribe();
    };
    return productsComponent;
}());
export { productsComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/productsComponent/products.component.ts.pre-build-optimizer.js